// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__1SchJ","sliderValues":"Slider_sliderValues__2KX0c","sliderValue":"Slider_sliderValue__2XVGj"};